(function (angular, window) {
    'use strict';

    window.THF.Angular.API
        .factory('ProductTableModel', ['$http', '$q', function ($http, $q) {
            var ProductTableModel = function () {

            };

            ProductTableModel.prototype = {
                hospitalProductTable: function (id) {
                    var deferred = $q.defer();
                    var req = {
                        method: 'GET',
                        url: '/api/v1/product-table/hospital/'+id
                    };

                    $http(req)
                        .success(function (response) {
                            deferred.resolve(response);
                        })
                        .error(function () {
                            deferred.reject();
                        });
                    return deferred.promise;
                },
                extrasProductTable: function (id) {
                    var deferred = $q.defer();
                    var req = {
                        method: 'GET',
                        url: '/api/v1/product-table/extras/'+id
                    };

                    $http(req)
                        .success(function (response) {
                            deferred.resolve(response);
                        })
                        .error(function () {
                            deferred.reject();
                        });
                    return deferred.promise;
                }
            };

            return new ProductTableModel();
        }]);

})(angular, window);
